import { useEffect, useState } from "react";
import { msUntilIso } from "@/lib/countdown";

/** Tick chaque seconde jusqu’à la date cible (ou arrêt si passée). */
export function useLiveCountdown(targetIso) {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    if (!targetIso) return undefined;
    const id = window.setInterval(() => setNowMs(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [targetIso]);

  const remainingMs = msUntilIso(targetIso, nowMs);
  const done = remainingMs === 0;
  return { remainingMs, done, nowMs };
}
